__turbopack_context__.v({
  "avatar": "Avatar-module-scss-module__qTn5Jq__avatar",
  "image": "Avatar-module-scss-module__qTn5Jq__image",
  "initials": "Avatar-module-scss-module__qTn5Jq__initials",
  "isLoaded": "Avatar-module-scss-module__qTn5Jq__isLoaded",
  "lg": "Avatar-module-scss-module__qTn5Jq__lg",
  "md": "Avatar-module-scss-module__qTn5Jq__md",
  "sm": "Avatar-module-scss-module__qTn5Jq__sm",
  "xl": "Avatar-module-scss-module__qTn5Jq__xl",
  "xs": "Avatar-module-scss-module__qTn5Jq__xs",
});
